const WIX_GET_DOMAIN_URL = 'https://manage.wix.com/get-domain';

export function buildDomainPurchaseUrl(
  domain: string,
  siteId?: string
): string {
  if (siteId) {
    const url = new URL(
      `https://manage.wix.com/dashboard/${siteId}/premium-express-checkout-app/bundle-selection`
    );
    url.searchParams.set('domainName', domain);
    url.searchParams.set('referralAdditionalInfo', 'wix_cli');
    return url.toString();
  }

  const url = new URL(WIX_GET_DOMAIN_URL);
  url.searchParams.set('domainName', domain);
  url.searchParams.set('flowType', 'purchase');
  url.searchParams.set('referralAdditionalInfo', 'wix_cli');
  return url.toString();
}
